import { ethers as t } from "ethers";
import { StakingPoolRewarderContractAbi as e } from "@deorderbook/contracts/abi";
import { StakingPoolRewarderAddress as n } from "@deorderbook/contracts";
import { signer as a, provider as i } from "./provider.mjs";
const c = (r = n) => new t.Contract(
  r,
  e
), f = (r = !1) => {
  const o = c();
  return r ? o.connect(a) : o.connect(i);
};
export {
  c as initStakingPoolRewarderContract,
  f as useStakingPoolRewarderContract
};
//# sourceMappingURL=stakingPoolRewarderContract.mjs.map
